import React from 'react';

const HeroBanner = ({ image, quote, attribution, tall = true }) => {
  return (
    <section
      className={`relative w-full ${tall ? 'h-[100vh] min-h-[640px]' : 'h-[70vh] min-h-[520px]'} overflow-hidden`}
    >
      {/* Background image with subtle grayscale + dark overlay */}
      <div
        className="absolute inset-0 bg-center bg-cover"
        style={{
          backgroundImage: `url(${image})`,
          filter: 'grayscale(100%) contrast(0.95) brightness(0.75)',
          transform: 'scale(1.02)',
        }}
      />
      <div className="absolute inset-0 bg-neutral-900/25" />

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center px-6">
        <div className="max-w-4xl text-center animate-fade-up">
          <p
            className="text-white font-serif italic leading-snug"
            style={{ fontSize: 'clamp(1.35rem, 2.6vw, 2.25rem)' }}
          >
            {quote}
          </p>
          {attribution && (
            <p
              className="mt-6 text-white font-serif italic"
              style={{ fontSize: 'clamp(1rem, 1.4vw, 1.25rem)' }}
            >
              {attribution}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
